export default "__VITE_ASSET__a2ca28b9__"